export const mrfsApi = 'information/bank-withdrawal/mrfs-details'

export const SeizerListBase = 'configuration/add-class'
export const seizerList = SeizerListBase + '/list'
export const assignUserHospitalApi = 'configuration/hospital/user-hospital'
export const storeDetailsApi = 'information/bank-withdrawal/store-details'
export const patientSearchList = 'information/patient-registration/search-list'

// Direct Donation
export const socialServiceHospitalReportApi = '/social-service/hospital-report/hospital-report-data'
export const socialServiceDateWiseHospitalReportApi = '/social-service/hospital-report/date-wise-hospital-report-data'
export const socialServiceHospitalTopSheetReportApi = '/social-service/hospital-report/hospital-report-top-sheet-data'

// Direct Donation
export const directDonationListApi = '/social-service/direct-donation/list'
export const directDonationStoreApi = '/social-service/direct-donation/store'
export const directDonationDetailsApi = '/social-service/direct-donation/details'

// Case History Api
const caseHistoryBase = '/social-service/case-history'
export const caseHistoryList = caseHistoryBase + '/list'
export const caseHistoryUploadFileApi = caseHistoryBase + '/file-upload'
export const caseHistoryStoreApi = caseHistoryBase + '/store'
export const caseHistoryUpdateApi = caseHistoryBase + '/update'
export const caseHistoryDetailsApi = caseHistoryBase + '/details'
export const caseHistoryToggleStatusApi = caseHistoryBase + '/toggle-status'
export const caseHistoryToggleVerifyApi = caseHistoryBase + '/toggle-verify'
export const patientDetailsApi = caseHistoryBase + '/patient_details'
export const PersonalFormCaseHistory = caseHistoryBase + '/personal_info'
export const PersonalInfoFormCaseHistory = caseHistoryBase + '/personal_info_case'
export const patientNewFormNoApi = caseHistoryBase + '/generate-new-form-no'
export const mappingFormDestroy = caseHistoryBase + '/mapping-form/destroy'
export const caseHistoryDeleteFileApi = caseHistoryBase + '/delete-uploaded-file'
export const caseHistoryDeleteDocApi = caseHistoryBase + '/doc'
export const AddressFamilyFormCaseHistory = caseHistoryBase + '/address_family_info'
export const AdmissionOtherFormCaseHistory = caseHistoryBase + '/admission_other_info'
export const MappingFormHealth = caseHistoryBase + '/health_info'

// Followup
export const followUpBase = '/social-service-management/follow-up-management/follow-up'
export const followUpGetPatientFormNo = followUpBase + '/get-patient-form-no'
export const followUpGetPatientAutoId = followUpBase + '/get-patient-auto-id'
export const followUpListApi = followUpBase + '/list'
export const followUpUploadFileApi = followUpBase + '/file-upload'
export const followUpStoreApi = followUpBase + '/store'
export const followUpUpdateApi = followUpBase + '/update'
export const followUpDeleteFileApi = followUpBase + '/delete-uploaded-file'
export const followUpDeleteDocApi = followUpBase + '/doc'
export const followUpToggleStatusApi = followUpBase + '/toggle-status'
export const followUpIsVerifiedApi = followUpBase + '/is-verified'

// Rehabilitation
export const rehabilitationListApi = '/social-service/rehabilitation/list'
export const rehabilitationDeatilApi = '/social-service/rehabilitation/detail'
export const rehabilitationStoreApi = '/social-service/rehabilitation/store'
export const rehabilitationUpdateApi = '/social-service/rehabilitation/update'
export const rehabilitationToggleStatusApi = '/social-service/rehabilitation/toggle-status'
export const patientRegDataApi = '/social-service/rehabilitation/patient-reg-data-by-form-no'
export const patientRegAutoDataApi = '/social-service/rehabilitation/patient-reg-data-by-auto_id'

// Social Service Dashboard
export const dashboardApi = '/social-service/dashboard/list'

// Delivery
export const socialServiceDeliveryList = '/social-service/delivery/list'
export const socialServiceDeliveryStoreApi = '/social-service/delivery/store'
export const socialPatientNewFormNoApi = 'information/patient-registration/generate-new-form-no'
export const getPatientInfoApi = 'information/patient-registration/get-patient-info'
export const socialServiceDetailsApi = '/social-service/delivery/details'
export const socialServiceDeliveryUpdateApi = '/social-service/delivery/update'
export const getPatientIdApi = '/social-service/delivery/get-patient-info'
export const getPatientNewFormNoApi = '/social-service/delivery/generate-new-form-no'

// Progress Report Numeric
export const patientDetailsCountApi = 'information/service-delivery/count'
export const patientDetailsFiscalYearCountApi = 'information/service-delivery/countFiscalYear'
export const incomeRegisterReportApi = 'store-management/stock/donation-count'
export const materialReportApi = 'store-management/stock/material-distribution'
export const socialServicePatientDetailsCountApi = 'information/service-delivery/social-service-patient-count'
export const socialServiceCashFlowReportApi = 'information/service-delivery/cash-flow-report'

// Progress Report Financial
export const monthlyFinancialProgressReportApi = '/social-service/reports/monthly-financial-progress-report'
export const weeklyFinancialProgressReportApi = '/social-service/reports/weekly-financial-progress-report'
export const weeklyNumericProgressReportApi = '/social-service/reports/weekly-numeric-progress-report'
export const panelDonationReportApi = '/social-service/reports/panel-donation-report'
export const weeklyAllFinancialProgressReportApi = '/social-service/reports/weekly-all-financial-progress-report'
export const weeklyAllNumericProgressReportApi = '/social-service/reports/weekly-all-numeric-progress-report'
export const yearlyFinancialProgressReportApi = '/social-service/reports/yearly-financial-progress-report'

// Other Reports
export const financialAidReportApi = '/social-service/reports/financial-aid-report'
export const bnswcReportApi = '/social-service/reports/bnswc-report'

// burnt victim assistance report
export const burntVictimAssistanceReportApi = '/social-service/reports/burnt-victim-assistance-report'
